import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as LoginController from '../Controller/LoginController';
import { loaderStateTrue, loaderStateFalse } from '../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp, setUserEntryType, setCrossPanelAccess } from '../Actions/LoginAction';
import Utility from '../../../Utility/Utility';
import LoginUtility from '../Utility/LoginUtility'

const AnotherLoginUrl = (props) => {
	const { loaderStateTrue, loaderStateFalse, history, logOutApp, setToken, setUserCredentials, setUserEntryType, setCrossPanelAccess } = props;
	const [messageReceived, setMessageReceived] = useState(false);

	useEffect(() => {
		const handleMessage = (event) => {
			if (event.data && event.data.type === 'AUTO_LOGIN_PAYLOAD') {
				setMessageReceived(true);
				loginSuccess(event.data.payload);
			}
		};

		window.addEventListener('message', handleMessage);

		// Signal to the opener that the listener is ready
		if (window.opener) {
			window.opener.postMessage({ type: 'AUTO_LOGIN_READY' }, '*');
		}

		// Timeout after 30 seconds if no message received
		const timeout = setTimeout(() => {
			if (!messageReceived) {
				history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/login`);
			}
		}, 3000);

		return () => {
			window.removeEventListener('message', handleMessage);
			clearTimeout(timeout);
		};
	}, []);

	const loginSuccess = async (loginDetails) => {
		try {
			const finalIdToken = loginDetails.token;
			const accessToken = loginDetails.accessToken;
			const refreshToken = loginDetails.refreshToken;
			const expiresIn = LoginUtility.getExpiryDetails(loginDetails.expiresIn);
			let userGroup = [];
			const organisationGroup = [];

			await setToken(finalIdToken, accessToken, expiresIn, refreshToken, userGroup, organisationGroup, '');
			loaderStateTrue();

			try {
				let filters = {};
				filters['filters'] = JSON.stringify({});
				const orgResponse = await LoginController.userOrganisationGet(filters);
				if (orgResponse.success && orgResponse.data?.UserOrgBranchRoleRelation) {
					userGroup = orgResponse.data.UserOrgBranchRoleRelation;
				}
				if (userGroup.length > 0) {
					setUserEntryType(userGroup[0]);
				}
				const hasPosAccess = orgResponse.data?.app_accesses?.has_pos === true;
				setCrossPanelAccess(hasPosAccess);
			} catch (orgError) {
				console.error('userOrganisationGet failed', orgError);
			}

			const userResponse = await LoginController.getCurrentUser();
			loaderStateFalse();

			if (userResponse.success) {
				const loginCredentials = userResponse.data;
				await setToken(finalIdToken, accessToken, expiresIn, refreshToken, userGroup, organisationGroup, '');
				setUserCredentials(loginCredentials);
				navigateAfterLogin(loginCredentials);
			} else {
				await logOutApp();
				history.push('/');
				Utility.toastNotifications(userResponse.message, "Error", "error");
			}
		} catch (e) {
			console.error('AnotherLoginUrl failed', e);
			loaderStateFalse();
			history.push(`/${localStorage.getItem('i18nextLng') || 'en'}/login`);
		}
	}

	const navigateAfterLogin = (loginCredentials) => {
		const userType = loginCredentials.user_details.user_type;
		const isSubscribed = loginCredentials.user_details.is_subscribed;
		const lng = localStorage.getItem('i18nextLng');
		const permissionEntryMenu = Utility.getRoleWiseEntryPoint ? Utility.getRoleWiseEntryPoint() : {};

		if (userType === "customer") {
			Utility.toastNotifications("Access denied", 'Error', 'error');
			logOutApp().then(() => props.history.push("/"));
		} else if (userType === "app_admin") {
			props.history.push(`/${lng}/home`);
		} else if ((userType === "admin" || userType === "revenue_manager" || userType === "revenue_staff") && isSubscribed) {
			if (userType === "revenue_staff") {
				props.history.push(`/${lng}/home`);
			} else {
				props.history.push(`/${lng}/dashboard`);
			}
		} else if (userType !== "admin" && isSubscribed) {
			if (userType === "agent" || userType === "agent_staff") {
				props.history.push(`/${lng}/agent/agent_booking`);
			} else {
				if (Utility.getRoleObjectByEventKey && Object.keys(Utility.getRoleObjectByEventKey('dashboard')).length > 0) {
					props.history.push(`/${lng}/dashboard`);
				} else if (permissionEntryMenu && Object.keys(permissionEntryMenu).length > 0) {
					props.history.push(permissionEntryMenu.path.replace(':lng', lng));
				} else {
					props.history.push(`/${lng}/home/branch`);
				}
			}
		} else {
			if (userType === "agent" || userType === "agent_staff") {
				props.history.push(`/${lng}/agent/branch`);
			} else if (permissionEntryMenu && Object.keys(permissionEntryMenu).length > 0) {
				props.history.push(permissionEntryMenu.path.replace(':lng', lng));
			} else {
				props.history.push(`/${lng}/home/branch`);
			}
		}
	}


	return (
		<></>
	);
}


const mapStateToProps = (globalState) => {
	return {
		token: globalState.LoginReducer.token,
		userCredentials: globalState.LoginReducer.userCredentials
	};
}



export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, setUserEntryType, logOutApp, setCrossPanelAccess })(AnotherLoginUrl);


